module.exports = __webpack_public_path__ + "img/logo.f9bd5c45.png";